import React from 'react'
import ModalGeneric from '../ModalGeneric'
import { ReactComponent as PencilWrite } from 'static/svg/pencil-write.svg'
import * as S from './styles'

const URL_REGULATION =
  'https://site.cfp.org.br/wp-content/uploads/2009/04/resolucao2009_01.pdf'

interface ModalWriteGuideProps {
  onClose: () => void;
}

const ModalWriteGuide: React.FC<ModalWriteGuideProps> = ({
  onClose,
}: ModalWriteGuideProps) => {
  return (
    <ModalGeneric
      modalTitle="Como fazer uma escrita psicológica?"
      hasButton
      btnText="Entendi"
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <S.Container>
        <S.ImageWrapper>
          <PencilWrite />
        </S.ImageWrapper>
        <S.StyledList>
          <S.StyledListItem>
            <S.StyledListNumber variant="content1">1</S.StyledListNumber>
            <S.ListItemDescription>
              Escreva da forma mais técnica e breve possível.
            </S.ListItemDescription>
          </S.StyledListItem>
          <S.StyledListItem>
            <S.StyledListNumber variant="content1">2</S.StyledListNumber>
            <S.ListItemDescription>
              Considere o fato de que outros profissionais da saúde terão acesso
              a este registro, como o psiquiatra ou o médico do trabalho da
              empresa do beneficiário.
            </S.ListItemDescription>
          </S.StyledListItem>
          <S.StyledListItem>
            <S.StyledListNumber variant="content1">3</S.StyledListNumber>
            <S.ListItemDescription>
              Considere que até mesmo o paciente poderá ter acesso ao registro,
              caso faça o requerimento de seu prontuário.
            </S.ListItemDescription>
          </S.StyledListItem>
        </S.StyledList>
        <S.MoreInformationText variant="content3" weight="light">
          Para mais informações,{' '}
          <S.MoreInformationLink href={URL_REGULATION} target="_blank">
            clique aqui
          </S.MoreInformationLink>{' '}
          e consulte a regulamentação do CFP (Conselho Federal de Psicologia)
          sobre a produção de documentos técnicos.
        </S.MoreInformationText>
      </S.Container>
    </ModalGeneric>
  )
}

export default ModalWriteGuide
